import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './airtraffic1.json';

const Airtraffic = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Aviation English, air traffic control, and travel vocabulary. B2 level grammar, reading, and speaking exercises."
            level="B2"
            title="Air Traffic"
            image="/Images/airdelay1.webp"
            seoTitle="Free English Lesson Plans: Air Traffic"
            seoDescription="English exam exercises on airtraffic1. Practice grammar, vocabulary, reading, and speaking for B2/C1 level exams."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Airtraffic;


